"use strict";
/**
 * @file 地图测距工具库
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var common_1 = require("../common");
var requireScript_1 = require("../utils/requireScript");
var WrapperHOC_1 = tslib_1.__importStar(require("../common/WrapperHOC"));
var Map_1 = require("../Map/Map");
var eventsMap = [
    'drawend',
    'addpoint',
    'removepolyline'
];
var methodsMap = {};
var DistanceTool = /** @class */ (function (_super) {
    tslib_1.__extends(DistanceTool, _super);
    function DistanceTool(props) {
        var _this = _super.call(this, props) || this;
        _this.options = [
            'tips',
            'followText',
            'unit',
            'lineColor',
            'lineStroke',
            'opacity',
            'lineStyle',
            'cursor',
            'secIcon',
            'closeIcon'
        ];
        return _this;
    }
    DistanceTool.prototype.componentDidMount = function () {
        this.initialize();
    };
    DistanceTool.prototype.componentWillUnmount = function () {
        this.destroy();
    };
    DistanceTool.prototype.destroy = function () {
        if (this.distancetool) {
            this.distancetool.close();
            // @ts-ignore
            this.instance = this.distancetool = undefined;
        }
    };
    DistanceTool.prototype.initialize = function () {
        var _this = this;
        var map = this.map = this.getMap();
        if (!map) {
            return;
        }
        this.destroy();
        var opts = this.getOptions();
        // 如果 BMapGLLib 已经加载过，会执行下面的
        if (window.BMapGLLib && BMapGLLib.DistanceTool) {
            this.instance = this.distancetool = new BMapGLLib.DistanceTool(map, opts);
            if (this.props.defaultOpen) {
                this.distancetool.open();
            }
        }
        // 如果第一次加载，会执行下面的
        if (!window.BMapGLLib || !BMapGLLib.DistanceTool) {
            var scriptUrl = this.props.scriptUrl || '//mapopen.bj.bcebos.com/github/BMapGLLib/DistanceTool/src/DistanceTool.js';
            requireScript_1.requireScript(scriptUrl)
                .then(function () {
                _this.instance = _this.distancetool = new BMapGLLib.DistanceTool(map, opts);
                // 因为是异步加载，所以不会自动注册事件和执行方法，需要手动注册和执行
                WrapperHOC_1.registerEvents(_this, _this.getInstance(_this), eventsMap);
                WrapperHOC_1.toggleMethods(_this, _this.getInstance(_this), methodsMap);
                if (_this.props.defaultOpen) {
                    _this.distancetool.open();
                }
            });
        }
    };
    DistanceTool.prototype.render = function () {
        return null;
    };
    DistanceTool.contextType = Map_1.MapContext;
    return DistanceTool;
}(common_1.Component));
DistanceTool.defaultProps = {
    defaultOpen: true
};
/**
 * 用来在地图上测量地理距离，单击添加拐点，双击结束测量。该组件属于不属于原生JSAPI，属于开源工具库[BMapGLLib](https://github.com/huiyan-fe/BMapGLLib)
 * @visibleName DistanceTool 地图测距工具
 */
exports.default = WrapperHOC_1.default(DistanceTool, eventsMap, methodsMap);
